import {
  Action,
  CTAType,
  log as logInteraction,
} from "@indeed/signals-schema/com/indeed/signals/schema/jspremium/Interaction";

import { openPaywallModal } from "../../../../../native-module/openPaywallModal";

interface HandleDisplayOnboardingParams {
  country: string;
  parentLogId: string;
  hostId: string;
  pageId: string;
  from: string;
  accountId: number;
  providerId: string;
  reload: () => void;
}

export const handleDisplayOnboarding = async ({
  country,
  parentLogId,
  hostId,
  pageId,
  from,
  accountId,
  providerId,
  reload,
}: HandleDisplayOnboardingParams): Promise<void> => {
  logInteraction({
    hostId,
    provider: providerId,
    elementName: "ctaButton",
    accountId,
    action: {
      Action: Action.BUTTON_CLICK,
    },
    country: {
      string: country,
    },
    ctaType: {
      CTAType: CTAType.PREMIUM,
    },
    parentLogId: {
      string: parentLogId,
    },
    pageId: {
      string: pageId,
    },
  });

  const res = await openPaywallModal({
    style: "PAYMENT",
    from,
    tk: parentLogId,
  });

  logInteraction({
    hostId,
    provider: providerId,
    elementName: "onboarding",
    accountId,
    action: {
      Action: Action.RESULT,
    },
    country: {
      string: country,
    },
    ctaType: {
      CTAType: CTAType.PREMIUM,
    },
    parentLogId: {
      string: parentLogId,
    },
    value: {
      string: res.paywallScreenResult.toString(),
    },
    pageId: {
      string: pageId,
    },
  });

  if (res.paywallScreenResult === "SUCCESS") {
    reload();
  }
};
